import { gql } from '@apollo/client'
import { POINT_OF_INTEREST_FRAGMENT } from '../fragments/PointOfInterestFragment'

export const GET_POINTS_OF_INTEREST = gql`
  query PointsOfInterest($input: PicOSPointsOfInterestInput!) {
    picosPointsOfInterest(input: $input) {
      count
      hasMore
      results {
        ...PointOfInterest
      }
    }
  }
  ${POINT_OF_INTEREST_FRAGMENT}
`
